import { ReactNode } from 'react';

import { Typography } from '@mui/material';

import styled from 'styled-components';

interface DataVizLineGraphProps {
  subTitle?: ReactNode;
  title?: ReactNode;
  children?: ReactNode;
}

const StyledDataVizLineGraph = styled.div`
  .subtitle {
    margin-top: ${({ theme }) => theme.spacing(1)};
  }
`;

export const DataVizLineGraph = ({ children, subTitle, title }: DataVizLineGraphProps) => {
  // TODO: use data when we want to rebuild this, otherwise use a pre-existing component
  return (
    <StyledDataVizLineGraph aria-hidden>
      <Typography variant="h4.bold">{title}</Typography>
      <Typography variant="body1" className="subtitle">
        {subTitle}
      </Typography>
      {children}
    </StyledDataVizLineGraph>
  );
};
